"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeFeatureFlagOverrides = void 0;
const FeatureFlagOverrides_1 = require("./FeatureFlagOverrides");
function initializeFeatureFlagOverrides() {
    if (typeof globalThis !== 'undefined') {
        globalThis.FEATURE_FLAG_OVERRIDES =
            FeatureFlagOverrides_1.FeatureFlagOverrides;
    }
}
exports.initializeFeatureFlagOverrides = initializeFeatureFlagOverrides;
